import AboutText from "./AboutText";

const About = () => {
  return (
    <div className="container mx-auto px-6 py-12 min-h-screen mt-10 lg:mt-20">
      <div className="flex flex-col md:flex-row gap-8 items-stretch">
        <div className="flex flex-col flex-1 gap-8">
          <div className="relative">
            <AboutText />
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
